// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1Ec5r","errors":"Errors_errors__3CTyw"};